import {Component} from '@angular/core';

export interface LeaseObject {
  objectMasterAssetTypeDescription: string;
  objectBrandDescription: string;
  objectCategoryDescription: string;
  objectSubcategoryDescription: string;
}

@Component({
  selector: 'app-detail-table',
  templateUrl: './lease-objects-table.component.html',
  styleUrls: ['../../detail-screen/detail-screen.component.css'],
})

export class LeaseObjectsTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: LeaseObject[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

}
